export default __webpack_public_path__ + "static/media/automated_wiring.f6d774f5.png";